import { useCallback } from "react";

/**
 * Custom hook for tracking analytics events with Umami.
 * Returns a stable track function that safely calls window.umami?.track.
 *
 * @example
 * const track = useEvent();
 * track(ANALYTICS_EVENTS.NAV_CLICK, { section: "about" });
 * track(ANALYTICS_EVENTS.PROJECT_CLICK, { project: "My Expense" });
 */
export function useEvent() {
  const track = useCallback((eventName, eventData) => {
    if (typeof window !== "undefined" && window.umami?.track) {
      window.umami.track(eventName, eventData);
    }
  }, []);

  return track;
}
